import { createContext, useContext } from "react";

import type { ExportContextValue } from "./types";

export const ExportContext = createContext<ExportContextValue | undefined>(
  undefined,
);

export const useExportContext = (): ExportContextValue => {
  const context = useContext(ExportContext);

  if (!context) {
    throw new Error("useExportContext must be used within an ExportProvider");
  }

  return context;
};
